<template>

  <div class="md:flex md:flex-col" id="dropdown">
    <div class="md:flex md:flex-col md:h-screen">
      <div class="md:flex md:flex-grow md:overflow-hidden">
        <main-menu :collapse="true" class="hidden flex-shrink-0 p-3 overflow-y-auto md:block" :routes="routes"
          @logout="openLogoutConfirm" @trigger-action="handleMenuAction" />

        <div class="flex flex-col w-full justify-between overflow-hidden bg-gray_bg min-h-screen">
          <div
            class="px-2 py-8 flex flex-col flex-1 md:p-6 md:overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200"
            scroll-region>
            <div class="md:text-md flex justify-end items-center p-4 w-full text-sm md:px-12 md:py-0">
              <notifications />

              <dropdown class="md:hidden" placement="bottom-end">
                <template #default>
                  <svg class="w-6 h-6 fill-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                  </svg>
                </template>
                <template #dropdown>
                  <div class="mt-2 px-8 py-4 bg-blue-900 rounded shadow-lg">
                    <main-menu :routes="routes" @logout="openLogoutConfirm" @trigger-action="handleMenuAction" />
                  </div>
                </template>
              </dropdown>
            </div>

            <flash-messages />

            <div class="bg mt-8 flex-1 flex flex-col">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de confirmação de saída -->
  <modal-delete ref="logoutModal" :show-trash-icon="false" />
  <unified-chat-modal ref="chatModal" @update-unread-count="updateChatUnreadCount" />

</template>


<script>

import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import Notifications from './Notifications.vue'
import Dropdown from '@/Shared/Dropdown'
import ModalDelete from '@/Shared/ModalDelete'
import UnifiedChatModal from '@/Shared/UnifiedChat/UnifiedChatModal.vue'

export default {

  components: {
    MainMenu,
    Notifications,
    Dropdown,
    FlashMessages,
    ModalDelete,
    UnifiedChatModal,
  },

  data() {
    return {
      chatUnreadCount: 0,
      routes: [
        {
          label: "Dashboard",
          icon: "fa-chart-column",
          link: "/provider/dashboard",
        },
        {
          label: "Relatório",
          icon: "fa-clipboard-list",
          link: "/provider/report",
        },
        {
          label: "Chat",
          icon: "fa-comment-dots",
          link: "/provider/chat",
          action: "open-provider-chat",
          badge: () => this.chatUnreadCount,
        },
        {
          label: "Notificações",
          icon: "fa-bell",
          link: "/provider/notification",
        },
        {
          label: "Perfil",
          icon: "fa-user",
          link: "/provider/profile",
        },
        {
          label: "Sair",
          icon: "fa-right-from-bracket",
          link: "/logout",
          method: "delete",
          as: "button",
        },
      ]
    }
  },

  setup() {
    return {
    }
  },
  methods: {
    openLogoutConfirm() {
      const msg = 'Deseja realmente sair?'
      this.$refs.logoutModal && this.$refs.logoutModal.openModalDelete({}, '/logout', msg)
    },
    handleMenuAction(action) {
      if (action === 'open-provider-chat') {
        this.$refs.chatModal && this.$refs.chatModal.openModal()
      }
    },
    updateChatUnreadCount(count) {
      this.chatUnreadCount = count || 0
    }
  }
}

</script>
